module.exports = __webpack_public_path__ + "static/004.thumb-072bb479242bddf410e6c3c0db8b9ba1.jpg";